// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2zaTY","content":"LoadingAlert_content__1Q12m"};